import React from 'react';
import { Link, Stack, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';
import { routePathMap } from 'modules/common';
import { useMessage } from 'modules/intl';

export const useStyles = makeStyles(() => ({
  textWrapper: {
    textAlign: 'left',
    whiteSpace: 'pre',
    display: 'flex',
    flexDirection: 'row',
    opacity: 1
  }
}));

export const BackgroundTimerToastElement: React.FC<{
  message: string;
  description: string;
}> = ({ message, description }) => {
  const classes = useStyles();
  const location = useLocation();
  const intlMessage = useMessage(message);

  return (
    <Stack
      data-testid="background-timer-toast-message-success"
      className={classes.textWrapper}
    >
      <Typography variant="body1">{intlMessage}</Typography>
      {location.pathname === routePathMap.notes ? (
        <Link href="#" variant="body1" underline="none">
          {description}
        </Link>
      ) : (
        <Typography variant="body1">{description}</Typography>
      )}
    </Stack>
  );
};
